module.exports = __webpack_public_path__ + "img/news-4.28bf0199.jpeg";